import { Directive, ElementRef, Renderer2, Input } from '@angular/core';
import * as VMasker from 'vanilla-masker';

@Directive({
    selector: '[CPF-CNPJ]',
})
export class CpfCnpjMaskDirective {

    @Input() public maskOption;

    public nativeElement: HTMLInputElement;

    constructor(
        public element: ElementRef,
        public render: Renderer2,
    ) {
        this.nativeElement = this.element.nativeElement;
    }

    public ngOnInit() {
        if (this.maskOption === 'cpf-cnpj') {
            this.render.listen(this.nativeElement, 'keyup', () => {
                const value = this.nativeElement.value.replace(/[_\W]+/g, '');
                const mask = (value.length <= 11) ? '999.999.999-99?9' : '99.999.999/9999-99';
                VMasker(this.nativeElement)
                    .maskPattern(mask);
            });
        } else if (this.maskOption === 'cpf') {
            VMasker(this.nativeElement)
                .maskPattern('999.999.999-99');
        } else if (this.maskOption === 'cnpj') {
            VMasker(this.nativeElement)
                .maskPattern('99.999.999/9999-99');
        }
    }
}
